<template>
    <el-dialog
        title="纪律播报"
        v-if="Bobaovideo1 && Bobaovideo2"
        :visible.sync="DialogbobaoVisible"
        width="500px"
        :close-on-click-modal="false"
        :show-close="comdata.mediatorself ? true : false"
        :before-close="handleClose"
        center>
        <div :class="[ comdata.mediatorself ? '':'pointer-e', 'voice-bobao']">
            <div class="bobao bobao-border">
                <div class="bobao-title">当事人的权利与义务</div>
                <div class="slider slider-flex">
                    <div class="slider-left">
                        <i :class="[audioParams1.isplay ?'el-icon-video-pause': 'el-icon-video-play', 'slider-icon']" @click="handlePlay1"></i>
                    </div>
                    <div class="slider-right">
                        <el-slider v-model="bobao1Value" :format-tooltip="formatTooltip1" :max="audioParams1.end" @change="handleChangeCur1"></el-slider>
                        <span class="start">0</span>
                        <span class="end">{{audioParams1.end}}s</span>
                    </div>
                </div>
                <audio autobuffer ref="audio" id="bobao1" @canplay="audioLoaded1()" @timeupdate="audioTimeupdate1" @ended="audioEnd1()">
                    <source :src="Bobaovideo1[0].value" type="audio/ogg">
                    <source :src="Bobaovideo1[0].value" type="audio/mpeg">
                </audio>
            </div>
            <div class="bobao">
                <div class="bobao-title">仲裁庭纪律</div>
                <div class="slider slider-flex">
                    <div class="slider-left">
                        <i :class="[audioParams2.isplay ?'el-icon-video-pause': 'el-icon-video-play', 'slider-icon']" @click="handlePlay2"></i>
                    </div>
                    <div class="slider-right">
                        <el-slider v-model="bobao2Value" :format-tooltip="formatTooltip2" :max="audioParams2.end" @change="handleChangeCur2"></el-slider>
                        <span class="start">0</span>
                        <span class="end">{{audioParams2.end}}s</span>
                    </div>
                </div>
                <audio autobuffer ref="audio" id="bobao2" @canplay="audioLoaded2()" @timeupdate="audioTimeupdate2" @ended="audioEnd2()">
                    <source :src="Bobaovideo2[0].value" type="audio/ogg">
                    <source :src="Bobaovideo2[0].value" type="audio/mpeg">
                </audio>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    components: {

    },
    props: ['Bobaovideo1', 'Bobaovideo2', 'ws', 'comdata'],
    data() {
        return {
            DialogbobaoVisible: false,
            bobao1Value: 0,
            bobao2Value: 0,
            audioParams1: {
                isplay: false,//是否播放状态
                end: 0
            },
            audioParams2: {
                isplay: false,//是否播放状态
                end: 0
            },
            audio1: '',
            audio2: ''
        }
    },
    created() {

    },
    mounted() {
        this.audio1 = document.getElementById('bobao1')
        this.audio2 = document.getElementById('bobao2')
    },
    methods: {
        handlePlay1(gettime) {
            this.audio1 = document.getElementById('bobao1')
            if(this.audioParams1.isplay) {
                this.audio1.pause();
                this.audioParams1.isplay = false
            } else {
                this.audio1.play();
                this.audioParams1.isplay = true
            }
            this.audio2.pause();            //音频1开启音频要初始化
            this.audio2.currentTime = 0
            this.audioParams2.isplay = false
            if(this.comdata.mediatorself) {
                let msgdata={}
                msgdata.event = "DISCIPLINE_PLAY"
                msgdata.data = {
                    playStatus: this.audioParams1.isplay ? 'START':'STOP', //  START 开始、STOP 暂停、END 结束
                    url: this.Bobaovideo1[0].value,
                    type: JSON.stringify({audiotype: 'bobao1', time: this.bobao1Value})
                }
                this.ws.send(JSON.stringify(msgdata))
            } else {
                this.audio1.currentTime = JSON.parse(gettime).time
                if(this.audio1.currentTime > this.audioParams1.end) {
                    this.audio1.pause();
                    this.audioParams1.isplay = true
                }
            }
        },
        formatTooltip1(val) {
            this.audio1 = document.getElementById('bobao1')
        },
        audioLoaded1() {
            //获取结束时间
            if(this.audio1) {
                this.audioParams1.end = Math.round(this.audio1.duration)
            }
        },
        audioTimeupdate1() {
            //获取更新秒数
            this.bobao1Value = Math.round(this.audio1.currentTime)
        },
        audioEnd1() {
            if(this.audio1.ended && !this.comdata.mediatorself) {
                let msgdata={}
                msgdata.event = "DISCIPLINE_PLAY"
                msgdata.data = {
                    playStatus: 'END', //  START 开始、STOP 暂停、END 结束
                    url: this.Bobaovideo1[0].value,
                    type: 'bobao1'
                }
                this.ws.send(JSON.stringify(msgdata))
                this.$message({
                    message: '当事人的权利与义务播报完成',
                    type: 'success'
                });
            }
            if(this.audio1.ended) {
                this.audioParams1.isplay = false
                this.audio1.currentTime = 0
            }
        },
        handleChangeCur1(val) {
            //拖动获取时间
            let msgdata={}
                msgdata.event = "DISCIPLINE_PLAY"
                msgdata.data = {
                    playStatus: 'START', //  START 开始、STOP 暂停、END 结束
                    url: this.Bobaovideo1[0].value,
                    type: JSON.stringify({audiotype: 'bobao1', time: val})
                }
            this.ws.send(JSON.stringify(msgdata))
            this.handleinput1(val)
            // if(this.audio1.currentTime > 0) {
            //     this.audio1.play();
            //     this.audioParams1.isplay = true
            // }
        },
        handleinput1(val) {
            if(this.audio1) {
                this.audio1.currentTime = val
                if(this.audio1.currentTime > this.audioParams1.end) {
                    this.audio1.pause();
                    this.audioParams1.isplay = true
                }
            }
        },
        handlePlay2(gettime) {
            this.audio2 = document.getElementById('bobao2')
            if(this.audioParams2.isplay) {
                this.audio2.pause();
                this.audioParams2.isplay = false
            } else {
                this.audio2.play();
                this.audioParams2.isplay = true
            }
            this.audio1.pause();
            this.audio1.currentTime = 0
            this.audioParams1.isplay = false
            if(this.comdata.mediatorself) {
                let msgdata={}
                msgdata.event = "DISCIPLINE_PLAY"
                msgdata.data = {
                    playStatus: this.audioParams2.isplay ? 'START':'STOP', //  START 开始、STOP 暂停、END 结束
                    url: this.Bobaovideo2[0].value,
                    type: JSON.stringify({audiotype: 'bobao2', time: this.bobao2Value})
                }
                this.ws.send(JSON.stringify(msgdata))
            } else {
                this.audio2.currentTime = JSON.parse(gettime).time
                if(this.audio2.currentTime > this.audioParams2.end) {
                    this.audio2.pause();
                    this.audioParams2.isplay = true
                }
            }
        },
        formatTooltip2(val) {
            this.audio2 = document.getElementById('bobao2')
        },
        audioLoaded2() {
            if(this.audio2) {
                this.audioParams2.end = Math.round(this.audio2.duration)
            }
        },
        audioTimeupdate2() {
            this.bobao2Value = Math.round(this.audio2.currentTime)
        },
        audioEnd2() {
            if(this.audio2.ended && !this.comdata.mediatorself) {
                let msgdata={}
                msgdata.event = "DISCIPLINE_PLAY"
                msgdata.data = {
                    playStatus: 'END', //  START 开始、STOP 暂停、END 结束
                    url: this.Bobaovideo2[0].value,
                    type: 'bobao2'
                }
                this.ws.send(JSON.stringify(msgdata))
                this.$message({
                    message: '仲裁庭纪律播报完成',
                    type: 'success'
                });
            }
            if(this.audio2.ended) {
                this.audioParams2.isplay = false
                this.audio2.currentTime = 0
            }
        },
        handleChangeCur2(val) {
             //拖动获取时间
            let msgdata={}
                msgdata.event = "DISCIPLINE_PLAY"
                msgdata.data = {
                    playStatus: 'START', //  START 开始、STOP 暂停、END 结束
                    url: this.Bobaovideo2[0].value,
                    type: JSON.stringify({audiotype: 'bobao2', time: val})
                }
                this.ws.send(JSON.stringify(msgdata))
            this.handleinput2(val)
        },
        handleinput2(val) {
            if(this.audio2) {
                this.audio2.currentTime = val
                if(this.audio2.currentTime > this.audioParams2.end) {
                    this.audio2.pause();
                    this.audioParams2.isplay = true
                }
            }
        },
        handleClose() {
            this.DialogbobaoVisible = false
            // this.audioParams1.isplay = false
            // this.audio1.currentTime = 0
            // this.audioParams2.isplay = false
            // this.audio2.currentTime = 0
            this.ws.send(JSON.stringify({event:'OTHER', data: {event:'SEND_BOBAO_DIALOG',dialog: false}}))
        }
    }
}
</script>

<style lang="scss">
    @import '../assets/css/meetingCss.scss';
</style>
